let hideTimeoutId = null;
let watchdogTimeoutId = null;
let loaderVisible = false;

const HIDE_DELAY_MS = 350;
const WATCHDOG_MS = 12000;

const getLoaderElement = () => {
  if (typeof document === "undefined") {
    return null;
  }

  return document.getElementById("loader-wrapper");
};

const clearTimers = () => {
  if (hideTimeoutId) {
    clearTimeout(hideTimeoutId);
    hideTimeoutId = null;
  }

  if (watchdogTimeoutId) {
    clearTimeout(watchdogTimeoutId);
    watchdogTimeoutId = null;
  }
};

const applyHiddenState = () => {
  const loader = getLoaderElement();
  if (!loader) {
    return;
  }

  loader.style.display = "none";
  loaderVisible = false;
};

const armWatchdog = () => {
  if (typeof window === "undefined") {
    return;
  }

  if (watchdogTimeoutId) {
    clearTimeout(watchdogTimeoutId);
  }

  watchdogTimeoutId = window.setTimeout(() => {
    applyHiddenState();
    watchdogTimeoutId = null;
  }, WATCHDOG_MS);
};

export const showLoader = () => {
  const loader = getLoaderElement();
  if (!loader) {
    return;
  }

  clearTimers();
  loader.style.display = "block";
  loaderVisible = true;
  armWatchdog();
};

export const hideLoader = (delayMs = HIDE_DELAY_MS) => {
  const loader = getLoaderElement();
  if (!loader) {
    return;
  }

  if (!loaderVisible && loader.style.display === "none") {
    clearTimers();
    return;
  }

  clearTimers();

  hideTimeoutId = window.setTimeout(() => {
    applyHiddenState();
    hideTimeoutId = null;
  }, delayMs);
};

export const forceHideLoader = () => {
  clearTimers();
  applyHiddenState();
};
